import { daluxfmServerApiSlice as api } from '../../apiSlice';
export const addTagTypes = [
  'Location',
  'Estate',
  'Building',
  'Lot',
  'Floor',
  'Room',
  'Document',
  'FileUpload',
  'Asset',
  'WorkOrder',
  'Ticket',
  'Company',
  'Product',
  'Invoice',
  'Checklist',
  'Zone',
] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      searchLocations: build.query<
        SearchLocationsApiResponse,
        SearchLocationsApiArg
      >({
        query: (queryArg) => ({
          url: `/2.0/locations`,
          params: {
            bookmark: queryArg.bookmark,
            limit: queryArg.limit,
          },
        }),
        providesTags: ['Location'],
      }),
      searchEstate: build.query<SearchEstateApiResponse, SearchEstateApiArg>({
        query: (queryArg) => ({
          url: `/2.0/estates`,
          params: {
            bookmark: queryArg.bookmark,
            limit: queryArg.limit,
          },
        }),
        providesTags: ['Estate'],
      }),
      addEstate: build.mutation<AddEstateApiResponse, AddEstateApiArg>({
        query: (queryArg) => ({
          url: `/3.0/estates`,
          method: 'POST',
          body: queryArg.estate,
        }),
        invalidatesTags: ['Estate'],
      }),
      getEstate: build.query<GetEstateApiResponse, GetEstateApiArg>({
        query: (queryArg) => ({ url: `/2.0/estates/${queryArg.estateId}` }),
        providesTags: ['Estate'],
      }),
      updateEstate: build.mutation<UpdateEstateApiResponse, UpdateEstateApiArg>(
        {
          query: (queryArg) => ({
            url: `/3.0/estates/${queryArg.estateId}`,
            method: 'PATCH',
            body: queryArg.estate,
          }),
          invalidatesTags: ['Estate'],
        },
      ),
      getEstateBuildings: build.query<
        GetEstateBuildingsApiResponse,
        GetEstateBuildingsApiArg
      >({
        query: (queryArg) => ({
          url: `/2.0/estates/${queryArg.estateId}/buildings`,
          params: {
            bookmark: queryArg.bookmark,
            limit: queryArg.limit,
          },
        }),
        providesTags: ['Estate'],
      }),
      getEstateLots: build.query<GetEstateLotsApiResponse, GetEstateLotsApiArg>(
        {
          query: (queryArg) => ({
            url: `/2.1/estates/${queryArg.estateId}/lots`,
            params: {
              bookmark: queryArg.bookmark,
              limit: queryArg.limit,
            },
          }),
          providesTags: ['Estate'],
        },
      ),
      searchBuilding: build.query<
        SearchBuildingApiResponse,
        SearchBuildingApiArg
      >({
        query: (queryArg) => ({
          url: `/2.0/buildings`,
          params: {
            bookmark: queryArg.bookmark,
            limit: queryArg.limit,
          },
        }),
        providesTags: ['Building'],
      }),
      addBuilding: build.mutation<AddBuildingApiResponse, AddBuildingApiArg>({
        query: (queryArg) => ({
          url: `/3.0/buildings`,
          method: 'POST',
          body: queryArg.building,
        }),
        invalidatesTags: ['Building'],
      }),
      getBuilding: build.query<GetBuildingApiResponse, GetBuildingApiArg>({
        query: (queryArg) => ({ url: `/2.0/buildings/${queryArg.buildingId}` }),
        providesTags: ['Building'],
      }),
      updateBuilding: build.mutation<
        UpdateBuildingApiResponse,
        UpdateBuildingApiArg
      >({
        query: (queryArg) => ({
          url: `/3.0/buildings/${queryArg.buildingId}`,
          method: 'PATCH',
          body: queryArg.building,
        }),
        invalidatesTags: ['Building'],
      }),
      searchBuildingFloors: build.query<
        SearchBuildingFloorsApiResponse,
        SearchBuildingFloorsApiArg
      >({
        query: (queryArg) => ({
          url: `/2.0/buildings/${queryArg.buildingId}/floors`,
          params: {
            bookmark: queryArg.bookmark,
            limit: queryArg.limit,
          },
        }),
        providesTags: ['Building'],
      }),
      searchBuildingAssets: build.query<
        SearchBuildingAssetsApiResponse,
        SearchBuildingAssetsApiArg
      >({
        query: (queryArg) => ({
          url: `/2.0/buildings/${queryArg.buildingId}/assets`,
          params: {
            bookmark: queryArg.bookmark,
            limit: queryArg.limit,
          },
        }),
        providesTags: ['Building'],
      }),
      searchBuildingDocuments: build.query<
        SearchBuildingDocumentsApiResponse,
        SearchBuildingDocumentsApiArg
      >({
        query: (queryArg) => ({
          url: `/2.1/buildings/${queryArg.buildingId}/documents`,
          params: {
            bookmark: queryArg.bookmark,
            limit: queryArg.limit,
          },
        }),
        providesTags: ['Building'],
      }),
      searchBuildingWorkOrders: build.query<
        SearchBuildingWorkOrdersApiResponse,
        SearchBuildingWorkOrdersApiArg
      >({
        query: (queryArg) => ({
          url: `/2.2/buildings/${queryArg.buildingId}/workorders`,
          params: {
            bookmark: queryArg.bookmark,
            limit: queryArg.limit,
          },
        }),
        providesTags: ['Building'],
      }),
      getBuildingPolygon: build.query<
        GetBuildingPolygonApiResponse,
        GetBuildingPolygonApiArg
      >({
        query: (queryArg) => ({
          url: `/2.0/buildings/${queryArg.buildingId}/polygon`,
        }),
        providesTags: ['Building'],
      }),
      updatePolygon: build.mutation<
        UpdatePolygonApiResponse,
        UpdatePolygonApiArg
      >({
        query: (queryArg) => ({
          url: `/2.0/buildings/${queryArg.buildingId}/polygon`,
          method: 'PATCH',
          body: queryArg.gis,
        }),
        invalidatesTags: ['Building'],
      }),
      getBuildingContactPersons: build.query<
        GetBuildingContactPersonsApiResponse,
        GetBuildingContactPersonsApiArg
      >({
        query: (queryArg) => ({
          url: `/2.0/buildings/${queryArg.buildingId}/contactpersons`,
          params: {
            bookmark: queryArg.bookmark,
            limit: queryArg.limit,
          },
        }),
        providesTags: ['Building'],
      }),
      postContactPersons: build.mutation<
        PostContactPersonsApiResponse,
        PostContactPersonsApiArg
      >({
        query: (queryArg) => ({
          url: `/2.0/buildings/${queryArg.buildingId}/contactpersons`,
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['Building'],
      }),
      searchLot: build.query<SearchLotApiResponse, SearchLotApiArg>({
        query: (queryArg) => ({
          url: `/2.1/lots`,
          params: {
            bookmark: queryArg.bookmark,
            limit: queryArg.limit,
          },
        }),
        providesTags: ['Lot'],
      }),
      addLot: build.mutation<AddLotApiResponse, AddLotApiArg>({
        query: (queryArg) => ({
          url: `/3.0/lots`,
          method: 'POST',
          body: queryArg.lot,
        }),
        invalidatesTags: ['Lot'],
      }),
      getLot: build.query<GetLotApiResponse, GetLotApiArg>({
        query: (queryArg) => ({ url: `/2.1/lots/${queryArg.lotId}` }),
        providesTags: ['Lot'],
      }),
      updateLot: build.mutation<UpdateLotApiResponse, UpdateLotApiArg>({
        query: (queryArg) => ({
          url: `/3.0/lots/${queryArg.lotId}`,
          method: 'PATCH',
          body: queryArg.lot,
        }),
        invalidatesTags: ['Lot'],
      }),
      getLotPolygon: build.query<GetLotPolygonApiResponse, GetLotPolygonApiArg>(
        {
          query: (queryArg) => ({ url: `/2.0/lots/${queryArg.lotId}/polygon` }),
          providesTags: ['Lot'],
        },
      ),
      addPolygon: build.mutation<AddPolygonApiResponse, AddPolygonApiArg>({
        query: (queryArg) => ({
          url: `/2.0/lots/${queryArg.lotId}/polygon`,
          method: 'PATCH',
          body: queryArg.gis,
        }),
        invalidatesTags: ['Lot'],
      }),
      getAllFloors: build.query<GetAllFloorsApiResponse, GetAllFloorsApiArg>({
        query: (queryArg) => ({
          url: `/2.0/floors`,
          params: {
            bookmark: queryArg.bookmark,
            limit: queryArg.limit,
          },
        }),
        providesTags: ['Floor'],
      }),
      addFloor: build.mutation<AddFloorApiResponse, AddFloorApiArg>({
        query: (queryArg) => ({
          url: `/2.0/floors`,
          method: 'POST',
          body: queryArg.floor,
        }),
        invalidatesTags: ['Floor'],
      }),
      getFloor: build.query<GetFloorApiResponse, GetFloorApiArg>({
        query: (queryArg) => ({ url: `/2.0/floors/${queryArg.floorId}` }),
        providesTags: ['Floor'],
      }),
      updateFloor: build.mutation<UpdateFloorApiResponse, UpdateFloorApiArg>({
        query: (queryArg) => ({
          url: `/2.0/floors/${queryArg.floorId}`,
          method: 'PATCH',
          body: queryArg.floor,
        }),
        invalidatesTags: ['Floor'],
      }),
      searchFloorRooms: build.query<
        SearchFloorRoomsApiResponse,
        SearchFloorRoomsApiArg
      >({
        query: (queryArg) => ({
          url: `/2.0/floors/${queryArg.floorId}/rooms`,
          params: {
            bookmark: queryArg.bookmark,
            limit: queryArg.limit,
          },
        }),
        providesTags: ['Floor'],
      }),
      searchRoom: build.query<SearchRoomApiResponse, SearchRoomApiArg>({
        query: (queryArg) => ({
          url: `/2.0/rooms`,
          params: {
            bookmark: queryArg.bookmark,
            limit: queryArg.limit,
          },
        }),
        providesTags: ['Room'],
      }),
      getRoom: build.query<GetRoomApiResponse, GetRoomApiArg>({
        query: (queryArg) => ({ url: `/2.0/rooms/${queryArg.roomId}` }),
        providesTags: ['Room'],
      }),
      updateRoom: build.mutation<UpdateRoomApiResponse, UpdateRoomApiArg>({
        query: (queryArg) => ({
          url: `/3.0/rooms/${queryArg.roomId}`,
          method: 'PATCH',
          body: queryArg.room,
        }),
        invalidatesTags: ['Room'],
      }),
      getRoomPolygon: build.query<
        GetRoomPolygonApiResponse,
        GetRoomPolygonApiArg
      >({
        query: (queryArg) => ({ url: `/2.0/rooms/${queryArg.roomId}/polygon` }),
        providesTags: ['Room'],
      }),
      searchDocument: build.query<
        SearchDocumentApiResponse,
        SearchDocumentApiArg
      >({
        query: (queryArg) => ({
          url: `/2.1/documents`,
          params: {
            bookmark: queryArg.bookmark,
            limit: queryArg.limit,
          },
        }),
        providesTags: ['Document'],
      }),
      createDocument: build.mutation<
        CreateDocumentApiResponse,
        CreateDocumentApiArg
      >({
        query: (queryArg) => ({
          url: `/2.1/documents/${queryArg.uploadSessionId}`,
          method: 'POST',
          body: queryArg.document,
        }),
        invalidatesTags: ['Document'],
      }),
      getDocument: build.query<GetDocumentApiResponse, GetDocumentApiArg>({
        query: (queryArg) => ({ url: `/2.1/documents/${queryArg.documentId}` }),
        providesTags: ['Document'],
      }),
      updateDocument: build.mutation<
        UpdateDocumentApiResponse,
        UpdateDocumentApiArg
      >({
        query: (queryArg) => ({
          url: `/2.1/documents/${queryArg.documentId}`,
          method: 'PATCH',
          body: queryArg.document,
          params: {
            uploadSessionIdQuery: queryArg.uploadSessionIdQuery,
          },
        }),
        invalidatesTags: ['Document'],
      }),
      getBinaryDocument: build.query<
        GetBinaryDocumentApiResponse,
        GetBinaryDocumentApiArg
      >({
        query: (queryArg) => ({
          url: `/2.0/documents/${queryArg.documentId}/filelink`,
        }),
        providesTags: ['Document'],
      }),
      getBinaryFileDocument: build.query<
        GetBinaryFileDocumentApiResponse,
        GetBinaryFileDocumentApiArg
      >({
        query: (queryArg) => ({
          url: `/2.0/documents/${queryArg.documentId}/binaryFileDownload`,
        }),
        providesTags: ['Document'],
      }),
      createUploadSession: build.query<
        CreateUploadSessionApiResponse,
        CreateUploadSessionApiArg
      >({
        query: (queryArg) => ({
          url: `/2.0/fileUploadSession`,
        }),
        providesTags: ['FileUpload'],
      }),
      uploadFile: build.mutation<UploadFileApiResponse, UploadFileApiArg>({
        query: (queryArg) => ({
          url: `/3.0/fileUpload/${queryArg.uploadSessionId}`,
          method: 'POST',
          body: queryArg.body,
          headers: {
            'X-File-Name': queryArg['X-File-Name'],
          },
        }),
        invalidatesTags: ['FileUpload'],
      }),
      uploadFilePart: build.mutation<
        UploadFilePartApiResponse,
        UploadFilePartApiArg
      >({
        query: (queryArg) => ({
          url: `/3.0/filePartUpload/${queryArg.uploadSessionId}`,
          method: 'POST',
          body: queryArg.body,
          headers: {
            'X-File-Name': queryArg['X-File-Name'],
            'X-Upload-Range': queryArg['X-Upload-Range'],
          },
        }),
        invalidatesTags: ['FileUpload'],
      }),
      searchAsset: build.query<SearchAssetApiResponse, SearchAssetApiArg>({
        query: (queryArg) => ({
          url: `/2.0/assets`,
          params: {
            bookmark: queryArg.bookmark,
            limit: queryArg.limit,
          },
        }),
        providesTags: ['Asset'],
      }),
      addAsset: build.mutation<AddAssetApiResponse, AddAssetApiArg>({
        query: (queryArg) => ({
          url: `/3.0/assets`,
          method: 'POST',
          body: queryArg.asset,
        }),
        invalidatesTags: ['Asset'],
      }),
      getAsset: build.query<GetAssetApiResponse, GetAssetApiArg>({
        query: (queryArg) => ({ url: `/2.0/assets/${queryArg.assetId}` }),
        providesTags: ['Asset'],
      }),
      updateAsset: build.mutation<UpdateAssetApiResponse, UpdateAssetApiArg>({
        query: (queryArg) => ({
          url: `/3.0/assets/${queryArg.assetId}`,
          method: 'PATCH',
          body: queryArg.asset,
        }),
        invalidatesTags: ['Asset'],
      }),
      searchSubAssets: build.query<
        SearchSubAssetsApiResponse,
        SearchSubAssetsApiArg
      >({
        query: (queryArg) => ({
          url: `/2.0/assets/${queryArg.assetId}/assets`,
          params: {
            bookmark: queryArg.bookmark,
            limit: queryArg.limit,
          },
        }),
        providesTags: ['Asset'],
      }),
      searchAssetDocuments: build.query<
        SearchAssetDocumentsApiResponse,
        SearchAssetDocumentsApiArg
      >({
        query: (queryArg) => ({
          url: `/2.1/assets/${queryArg.assetId}/documents`,
          params: {
            bookmark: queryArg.bookmark,
            limit: queryArg.limit,
          },
        }),
        providesTags: ['Asset'],
      }),
      searchAssetWorkOrders: build.query<
        SearchAssetWorkOrdersApiResponse,
        SearchAssetWorkOrdersApiArg
      >({
        query: (queryArg) => ({
          url: `/2.2/assets/${queryArg.assetId}/workorders`,
          params: {
            bookmark: queryArg.bookmark,
            limit: queryArg.limit,
          },
        }),
        providesTags: ['Asset'],
      }),
      searchAssetPhotos: build.query<
        SearchAssetPhotosApiResponse,
        SearchAssetPhotosApiArg
      >({
        query: (queryArg) => ({
          url: `/2.0/assets/${queryArg.assetId}/photos`,
          params: {
            bookmark: queryArg.bookmark,
            limit: queryArg.limit,
          },
        }),
        providesTags: ['Asset'],
      }),
      searchClassification: build.query<
        SearchClassificationApiResponse,
        SearchClassificationApiArg
      >({
        query: (queryArg) => ({
          url: `/2.0/assets/classifications`,
          params: {
            bookmark: queryArg.bookmark,
            limit: queryArg.limit,
          },
        }),
        providesTags: ['Asset'],
      }),
      searchWorkOrder: build.query<
        SearchWorkOrderApiResponse,
        SearchWorkOrderApiArg
      >({
        query: (queryArg) => ({
          url: `/2.2/workorders`,
          params: {
            bookmark: queryArg.bookmark,
            limit: queryArg.limit,
          },
        }),
        providesTags: ['WorkOrder'],
      }),
      createWorkOrder: build.mutation<
        CreateWorkOrderApiResponse,
        CreateWorkOrderApiArg
      >({
        query: (queryArg) => ({
          url: `/2.2/workorders`,
          method: 'POST',
          body: queryArg.workOrder,
        }),
        invalidatesTags: ['WorkOrder'],
      }),
      getWorkOrder: build.query<GetWorkOrderApiResponse, GetWorkOrderApiArg>({
        query: (queryArg) => ({
          url: `/2.2/workorders/${queryArg.workOrderId}`,
        }),
        providesTags: ['WorkOrder'],
      }),
      updateWorkOrder: build.mutation<
        UpdateWorkOrderApiResponse,
        UpdateWorkOrderApiArg
      >({
        query: (queryArg) => ({
          url: `/2.2/workorders/${queryArg.workOrderId}`,
          method: 'PATCH',
          body: queryArg.workOrder,
        }),
        invalidatesTags: ['WorkOrder'],
      }),
      searchWorkOrderDocuments: build.query<
        SearchWorkOrderDocumentsApiResponse,
        SearchWorkOrderDocumentsApiArg
      >({
        query: (queryArg) => ({
          url: `/2.1/workorders/${queryArg.workOrderId}/documents`,
          params: {
            bookmark: queryArg.bookmark,
            limit: queryArg.limit,
          },
        }),
        providesTags: ['WorkOrder'],
      }),
      createDocumentOnWorkOrder: build.mutation<
        CreateDocumentOnWorkOrderApiResponse,
        CreateDocumentOnWorkOrderApiArg
      >({
        query: (queryArg) => ({
          url: `/2.1/workorders/${queryArg.workOrderId}/documents/${queryArg.uploadSessionId}`,
          method: 'POST',
          body: queryArg.document,
        }),
        invalidatesTags: ['WorkOrder'],
      }),
      searchWorkOrderPhotos: build.query<
        SearchWorkOrderPhotosApiResponse,
        SearchWorkOrderPhotosApiArg
      >({
        query: (queryArg) => ({
          url: `/2.0/workorders/${queryArg.workOrderId}/photos`,
          params: {
            bookmark: queryArg.bookmark,
            limit: queryArg.limit,
          },
        }),
        providesTags: ['WorkOrder'],
      }),
      createPhotoOnWorkOrder: build.mutation<
        CreatePhotoOnWorkOrderApiResponse,
        CreatePhotoOnWorkOrderApiArg
      >({
        query: (queryArg) => ({
          url: `/2.0/workorders/${queryArg.workOrderId}/photos/${queryArg.uploadSessionId}`,
          method: 'POST',
          body: queryArg.photo,
        }),
        invalidatesTags: ['WorkOrder'],
      }),
      searchWorkOrderHistory: build.query<
        SearchWorkOrderHistoryApiResponse,
        SearchWorkOrderHistoryApiArg
      >({
        query: (queryArg) => ({
          url: `/2.0/workorders/${queryArg.workOrderId}/history`,
          params: {
            bookmark: queryArg.bookmark,
            limit: queryArg.limit,
          },
        }),
        providesTags: ['WorkOrder'],
      }),
      searchWorkOrderTimeRegistrations: build.query<
        SearchWorkOrderTimeRegistrationsApiResponse,
        SearchWorkOrderTimeRegistrationsApiArg
      >({
        query: (queryArg) => ({
          url: `/2.0/workorders/${queryArg.workOrderId}/timeregistrations`,
          params: {
            bookmark: queryArg.bookmark,
            limit: queryArg.limit,
          },
        }),
        providesTags: ['WorkOrder'],
      }),
      searchWorkOrderTemplates: build.query<
        SearchWorkOrderTemplatesApiResponse,
        SearchWorkOrderTemplatesApiArg
      >({
        query: (queryArg) => ({
          url: `/2.0/workorders/templates`,
          params: {
            bookmark: queryArg.bookmark,
            limit: queryArg.limit,
          },
        }),
        providesTags: ['WorkOrder'],
      }),
      searchWorkOrderPriorities: build.query<
        SearchWorkOrderPrioritiesApiResponse,
        SearchWorkOrderPrioritiesApiArg
      >({
        query: (queryArg) => ({
          url: `/2.0/workorders/priorities`,
          params: {
            bookmark: queryArg.bookmark,
            limit: queryArg.limit,
          },
        }),
        providesTags: ['WorkOrder'],
      }),
      searchTeams: build.query<SearchTeamsApiResponse, SearchTeamsApiArg>({
        query: (queryArg) => ({
          url: `/2.0/workorders/teams`,
          params: {
            bookmark: queryArg.bookmark,
            limit: queryArg.limit,
          },
        }),
        providesTags: ['WorkOrder'],
      }),
      searchWorkOrderStatuses: build.query<
        SearchWorkOrderStatusesApiResponse,
        SearchWorkOrderStatusesApiArg
      >({
        query: (queryArg) => ({
          url: `/2.0/workorders/statuses`,
          params: {
            bookmark: queryArg.bookmark,
            limit: queryArg.limit,
          },
        }),
        providesTags: ['WorkOrder'],
      }),
      searchWorkOrderTimeAccounts: build.query<
        SearchWorkOrderTimeAccountsApiResponse,
        SearchWorkOrderTimeAccountsApiArg
      >({
        query: (queryArg) => ({
          url: `/2.0/workorders/timeaccounts`,
          params: {
            bookmark: queryArg.bookmark,
            limit: queryArg.limit,
          },
        }),
        providesTags: ['WorkOrder'],
      }),
      searchExternalWorkOrder: build.query<
        SearchExternalWorkOrderApiResponse,
        SearchExternalWorkOrderApiArg
      >({
        query: (queryArg) => ({
          url: `/2.2/external/workorders`,
          params: {
            bookmark: queryArg.bookmark,
            limit: queryArg.limit,
          },
        }),
        providesTags: ['WorkOrder'],
      }),
      getExternalWorkOrder: build.query<
        GetExternalWorkOrderApiResponse,
        GetExternalWorkOrderApiArg
      >({
        query: (queryArg) => ({
          url: `/2.2/external/workorders/${queryArg.workOrderId}`,
        }),
        providesTags: ['WorkOrder'],
      }),
      updateExternalWorkOrder: build.mutation<
        UpdateExternalWorkOrderApiResponse,
        UpdateExternalWorkOrderApiArg
      >({
        query: (queryArg) => ({
          url: `/2.2/external/workorders/${queryArg.workOrderId}`,
          method: 'PATCH',
          body: queryArg.workOrderExternal,
        }),
        invalidatesTags: ['WorkOrder'],
      }),
      searchExternalWorkOrderHistory: build.query<
        SearchExternalWorkOrderHistoryApiResponse,
        SearchExternalWorkOrderHistoryApiArg
      >({
        query: (queryArg) => ({
          url: `/2.0/external/workorders/${queryArg.workOrderId}/history`,
          params: {
            bookmark: queryArg.bookmark,
            limit: queryArg.limit,
          },
        }),
        providesTags: ['WorkOrder'],
      }),
      createNote: build.mutation<CreateNoteApiResponse, CreateNoteApiArg>({
        query: (queryArg) => ({
          url: `/2.0/external/workorders/${queryArg.workOrderId}/note`,
          method: 'POST',
          body: queryArg.message,
        }),
        invalidatesTags: ['WorkOrder'],
      }),
      sendMessage: build.mutation<SendMessageApiResponse, SendMessageApiArg>({
        query: (queryArg) => ({
          url: `/2.0/external/workorders/${queryArg.workOrderId}/message`,
          method: 'POST',
          body: queryArg.message,
        }),
        invalidatesTags: ['WorkOrder'],
      }),
      addInformation: build.mutation<
        AddInformationApiResponse,
        AddInformationApiArg
      >({
        query: (queryArg) => ({
          url: `/2.0/external/workorders/${queryArg.workOrderId}/addinformation`,
          method: 'POST',
          body: queryArg.addInformation,
        }),
        invalidatesTags: ['WorkOrder'],
      }),
      addTimeUsage: build.mutation<AddTimeUsageApiResponse, AddTimeUsageApiArg>(
        {
          query: (queryArg) => ({
            url: `/2.0/external/workorders/${queryArg.workOrderId}/timeusage`,
            method: 'POST',
            body: queryArg.timeUsage,
          }),
          invalidatesTags: ['WorkOrder'],
        },
      ),
      confirmWorkOrderExternal: build.mutation<
        ConfirmWorkOrderExternalApiResponse,
        ConfirmWorkOrderExternalApiArg
      >({
        query: (queryArg) => ({
          url: `/2.0/external/workorders/${queryArg.workOrderId}/confirm`,
          method: 'POST',
          body: queryArg.confirm,
        }),
        invalidatesTags: ['WorkOrder'],
      }),
      rejectWorkOrderExternal: build.mutation<
        RejectWorkOrderExternalApiResponse,
        RejectWorkOrderExternalApiArg
      >({
        query: (queryArg) => ({
          url: `/2.0/external/workorders/${queryArg.workOrderId}/reject`,
          method: 'POST',
        }),
        invalidatesTags: ['WorkOrder'],
      }),
      completeWorkOrderExternal: build.mutation<
        CompleteWorkOrderExternalApiResponse,
        CompleteWorkOrderExternalApiArg
      >({
        query: (queryArg) => ({
          url: `/2.0/external/workorders/${queryArg.workOrderId}/complete`,
          method: 'POST',
        }),
        invalidatesTags: ['WorkOrder'],
      }),
      searchExternalWorkOrderStatuses: build.query<
        SearchExternalWorkOrderStatusesApiResponse,
        SearchExternalWorkOrderStatusesApiArg
      >({
        query: (queryArg) => ({
          url: `/2.0/external/workorders/statuses`,
          params: {
            bookmark: queryArg.bookmark,
            limit: queryArg.limit,
          },
        }),
        providesTags: ['WorkOrder'],
      }),
      searchTicket: build.query<SearchTicketApiResponse, SearchTicketApiArg>({
        query: (queryArg) => ({
          url: `/2.0/tickets`,
          params: {
            bookmark: queryArg.bookmark,
            limit: queryArg.limit,
          },
        }),
        providesTags: ['Ticket'],
      }),
      createTicket: build.mutation<CreateTicketApiResponse, CreateTicketApiArg>(
        {
          query: (queryArg) => ({
            url: `/2.0/tickets`,
            method: 'POST',
            body: queryArg.ticket,
          }),
          invalidatesTags: ['Ticket'],
        },
      ),
      getTicket: build.query<GetTicketApiResponse, GetTicketApiArg>({
        query: (queryArg) => ({ url: `/2.0/tickets/${queryArg.ticketId}` }),
        providesTags: ['Ticket'],
      }),
      updateTicket: build.mutation<UpdateTicketApiResponse, UpdateTicketApiArg>(
        {
          query: (queryArg) => ({
            url: `/2.0/tickets/${queryArg.ticketId}`,
            method: 'PATCH',
            body: queryArg.ticket,
          }),
          invalidatesTags: ['Ticket'],
        },
      ),
      searchTicketHistory: build.query<
        SearchTicketHistoryApiResponse,
        SearchTicketHistoryApiArg
      >({
        query: (queryArg) => ({
          url: `/2.0/tickets/${queryArg.ticketId}/history`,
          params: {
            bookmark: queryArg.bookmark,
            limit: queryArg.limit,
          },
        }),
        providesTags: ['Ticket'],
      }),
      searchTicketPhotos: build.query<
        SearchTicketPhotosApiResponse,
        SearchTicketPhotosApiArg
      >({
        query: (queryArg) => ({
          url: `/2.0/tickets/${queryArg.ticketId}/photos`,
          params: {
            bookmark: queryArg.bookmark,
            limit: queryArg.limit,
          },
        }),
        providesTags: ['Ticket'],
      }),
      searchTicketTopics: build.query<
        SearchTicketTopicsApiResponse,
        SearchTicketTopicsApiArg
      >({
        query: (queryArg) => ({
          url: `/2.0/tickets/topics`,
          params: {
            bookmark: queryArg.bookmark,
            limit: queryArg.limit,
          },
        }),
        providesTags: ['Ticket'],
      }),
      searchTicketTopicBuildings: build.query<
        SearchTicketTopicBuildingsApiResponse,
        SearchTicketTopicBuildingsApiArg
      >({
        query: (queryArg) => ({
          url: `/2.0/tickets/topics/${queryArg.topicId}/buildings`,
          params: {
            bookmark: queryArg.bookmark,
            limit: queryArg.limit,
          },
        }),
        providesTags: ['Ticket'],
      }),
      searchTicketTopicClassifications: build.query<
        SearchTicketTopicClassificationsApiResponse,
        SearchTicketTopicClassificationsApiArg
      >({
        query: (queryArg) => ({
          url: `/2.0/tickets/topics/${queryArg.topicId}/classifications`,
          params: {
            bookmark: queryArg.bookmark,
            limit: queryArg.limit,
          },
        }),
        providesTags: ['Ticket'],
      }),
      searchTicketTopicLots: build.query<
        SearchTicketTopicLotsApiResponse,
        SearchTicketTopicLotsApiArg
      >({
        query: (queryArg) => ({
          url: `/2.1/tickets/topics/${queryArg.topicId}/lots`,
          params: {
            bookmark: queryArg.bookmark,
            limit: queryArg.limit,
          },
        }),
        providesTags: ['Ticket'],
      }),
      searchTicketTopicRoomTypes: build.query<
        SearchTicketTopicRoomTypesApiResponse,
        SearchTicketTopicRoomTypesApiArg
      >({
        query: (queryArg) => ({
          url: `/2.0/tickets/topics/${queryArg.topicId}/roomTypes`,
          params: {
            bookmark: queryArg.bookmark,
            limit: queryArg.limit,
          },
        }),
        providesTags: ['Ticket'],
      }),
      searchStatuses: build.query<
        SearchStatusesApiResponse,
        SearchStatusesApiArg
      >({
        query: (queryArg) => ({
          url: `/2.0/tickets/statuses`,
          params: {
            bookmark: queryArg.bookmark,
            limit: queryArg.limit,
          },
        }),
        providesTags: ['Ticket'],
      }),
      sendMessagePhoto: build.mutation<
        SendMessagePhotoApiResponse,
        SendMessagePhotoApiArg
      >({
        query: (queryArg) => ({
          url: `/2.0/tickets/${queryArg.ticketId}/sendMessagePhoto`,
          method: 'POST',
          body: queryArg.messagePhoto,
        }),
        invalidatesTags: ['Ticket'],
      }),
      searchCompany: build.query<SearchCompanyApiResponse, SearchCompanyApiArg>(
        {
          query: (queryArg) => ({
            url: `/2.0/companies`,
            params: {
              bookmark: queryArg.bookmark,
              limit: queryArg.limit,
            },
          }),
          providesTags: ['Company'],
        },
      ),
      getCompany: build.query<GetCompanyApiResponse, GetCompanyApiArg>({
        query: (queryArg) => ({ url: `/2.0/companies/${queryArg.companyId}` }),
        providesTags: ['Company'],
      }),
      searchCompanyWorkOrders: build.query<
        SearchCompanyWorkOrdersApiResponse,
        SearchCompanyWorkOrdersApiArg
      >({
        query: (queryArg) => ({
          url: `/2.2/companies/${queryArg.companyId}/workorders`,
          params: {
            bookmark: queryArg.bookmark,
            limit: queryArg.limit,
          },
        }),
        providesTags: ['Company'],
      }),
      searchProduct: build.query<SearchProductApiResponse, SearchProductApiArg>(
        {
          query: (queryArg) => ({
            url: `/2.0/products`,
            params: {
              bookmark: queryArg.bookmark,
              limit: queryArg.limit,
            },
          }),
          providesTags: ['Product'],
        },
      ),
      createProduct: build.mutation<
        CreateProductApiResponse,
        CreateProductApiArg
      >({
        query: (queryArg) => ({
          url: `/3.0/products`,
          method: 'POST',
          body: queryArg.product,
        }),
        invalidatesTags: ['Product'],
      }),
      getProduct: build.query<GetProductApiResponse, GetProductApiArg>({
        query: (queryArg) => ({ url: `/2.0/products/${queryArg.productId}` }),
        providesTags: ['Product'],
      }),
      updateProduct: build.mutation<
        UpdateProductApiResponse,
        UpdateProductApiArg
      >({
        query: (queryArg) => ({
          url: `/3.0/products/${queryArg.productId}`,
          method: 'PATCH',
          body: queryArg.product,
        }),
        invalidatesTags: ['Product'],
      }),
      searchProductsDocuments: build.query<
        SearchProductsDocumentsApiResponse,
        SearchProductsDocumentsApiArg
      >({
        query: (queryArg) => ({
          url: `/2.1/products/${queryArg.productId}/documents`,
          params: {
            bookmark: queryArg.bookmark,
            limit: queryArg.limit,
          },
        }),
        providesTags: ['Product'],
      }),
      searchInvoice: build.query<SearchInvoiceApiResponse, SearchInvoiceApiArg>(
        {
          query: (queryArg) => ({
            url: `/2.0/invoices`,
            params: {
              bookmark: queryArg.bookmark,
              limit: queryArg.limit,
            },
          }),
          providesTags: ['Invoice'],
        },
      ),
      createInvoice: build.mutation<
        CreateInvoiceApiResponse,
        CreateInvoiceApiArg
      >({
        query: (queryArg) => ({
          url: `/2.0/invoices`,
          method: 'POST',
          body: queryArg.invoice,
        }),
        invalidatesTags: ['Invoice'],
      }),
      getInvoice: build.query<GetInvoiceApiResponse, GetInvoiceApiArg>({
        query: (queryArg) => ({ url: `/2.0/invoices/${queryArg.invoiceId}` }),
        providesTags: ['Invoice'],
      }),
      updateInvoice: build.mutation<
        UpdateInvoiceApiResponse,
        UpdateInvoiceApiArg
      >({
        query: (queryArg) => ({
          url: `/2.0/invoices/${queryArg.invoiceId}`,
          method: 'PATCH',
          body: queryArg.invoice,
        }),
        invalidatesTags: ['Invoice'],
      }),
      searchInvoicesDocuments: build.query<
        SearchInvoicesDocumentsApiResponse,
        SearchInvoicesDocumentsApiArg
      >({
        query: (queryArg) => ({
          url: `/2.1/invoices/${queryArg.invoiceId}/documents`,
          params: {
            bookmark: queryArg.bookmark,
            limit: queryArg.limit,
          },
        }),
        providesTags: ['Invoice'],
      }),
      createDocumentOnInvoice: build.mutation<
        CreateDocumentOnInvoiceApiResponse,
        CreateDocumentOnInvoiceApiArg
      >({
        query: (queryArg) => ({
          url: `/2.1/invoices/${queryArg.invoiceId}/documents/${queryArg.uploadSessionId}`,
          method: 'POST',
          body: queryArg.document,
        }),
        invalidatesTags: ['Invoice'],
      }),
      searchInvoiceStatuses: build.query<
        SearchInvoiceStatusesApiResponse,
        SearchInvoiceStatusesApiArg
      >({
        query: (queryArg) => ({
          url: `/2.0/invoices/statuses`,
          params: {
            bookmark: queryArg.bookmark,
            limit: queryArg.limit,
          },
        }),
        providesTags: ['Invoice'],
      }),
      searchChecklist: build.query<
        SearchChecklistApiResponse,
        SearchChecklistApiArg
      >({
        query: (queryArg) => ({
          url: `/2.0/checklists`,
          params: {
            bookmark: queryArg.bookmark,
            limit: queryArg.limit,
          },
        }),
        providesTags: ['Checklist'],
      }),
      getChecklist: build.query<GetChecklistApiResponse, GetChecklistApiArg>({
        query: (queryArg) => ({
          url: `/2.0/checklists/${queryArg.checklistId}`,
        }),
        providesTags: ['Checklist'],
      }),
      searchChecklistAttachment: build.query<
        SearchChecklistAttachmentApiResponse,
        SearchChecklistAttachmentApiArg
      >({
        query: (queryArg) => ({
          url: `/2.0/checklists/${queryArg.checklistId}/attachments`,
          params: {
            bookmark: queryArg.bookmark,
            limit: queryArg.limit,
          },
        }),
        providesTags: ['Checklist'],
      }),
      searchZones: build.query<SearchZonesApiResponse, SearchZonesApiArg>({
        query: (queryArg) => ({
          url: `/1.0/zones`,
          params: {
            bookmark: queryArg.bookmark,
            limit: queryArg.limit,
          },
        }),
        providesTags: ['Zone'],
      }),
      getZone: build.query<GetZoneApiResponse, GetZoneApiArg>({
        query: (queryArg) => ({ url: `/1.0/zones/${queryArg.zoneId}` }),
        providesTags: ['Zone'],
      }),
      searchZoneDocuments: build.query<
        SearchZoneDocumentsApiResponse,
        SearchZoneDocumentsApiArg
      >({
        query: (queryArg) => ({
          url: `/1.0/zones/${queryArg.zoneId}/documents`,
          params: {
            bookmark: queryArg.bookmark,
            limit: queryArg.limit,
          },
        }),
        providesTags: ['Zone'],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as daluxfmServerOpenApi };
export type SearchLocationsApiResponse =
  /** status 200 Locations sorted by Name */ LocationResponseList;
export type SearchLocationsApiArg = {
  /** used to scroll through the data */
  bookmark?: number | null;
  /** maximum number of records to return (<= 100) */
  limit?: number | null;
};
export type SearchEstateApiResponse =
  /** status 200 Estates sorted by last change date */ EstateResponseList;
export type SearchEstateApiArg = {
  /** used to scroll through the data */
  bookmark?: number | null;
  /** maximum number of records to return (<= 100) */
  limit?: number | null;
};
export type AddEstateApiResponse =
  /** status 201 New estate created */ EstateResponse;
export type AddEstateApiArg = {
  /** Estate data to add. Links and metadata entries are ignored */
  estate: Estate;
};
export type GetEstateApiResponse =
  /** status 200 The requested estate */ EstateResponse;
export type GetEstateApiArg = {
  /** Id of the requested estate */
  estateId: string;
};
export type UpdateEstateApiResponse =
  /** status 200 The requested estate */ EstateResponse;
export type UpdateEstateApiArg = {
  /** Id of the requested estate */
  estateId: string;
  estate: Estate;
};
export type GetEstateBuildingsApiResponse =
  /** status 200 Buildings associated with the estate */ BuildingResponseList;
export type GetEstateBuildingsApiArg = {
  /** used to scroll through the data */
  bookmark?: number | null;
  /** maximum number of records to return (<= 100) */
  limit?: number | null;
  /** Id of the requested estate */
  estateId: string;
};
export type GetEstateLotsApiResponse =
  /** status 200 Lots associated with the estate */ LotResponseList;
export type GetEstateLotsApiArg = {
  /** used to scroll through the data */
  bookmark?: number | null;
  /** maximum number of records to return (<= 100) */
  limit?: number | null;
  /** Id of the requested estate */
  estateId: string;
};
export type SearchBuildingApiResponse =
  /** status 200 Buildings associated with the estate */ BuildingResponseList;
export type SearchBuildingApiArg = {
  /** used to scroll through the data */
  bookmark?: number | null;
  /** maximum number of records to return (<= 100) */
  limit?: number | null;
};
export type AddBuildingApiResponse =
  /** status 201 New building created */ BuildingResponse;
export type AddBuildingApiArg = {
  building: Building;
};
export type GetBuildingApiResponse =
  /** status 200 The requested building */ BuildingResponse;
export type GetBuildingApiArg = {
  /** Id of the requested building */
  buildingId: string;
};
export type UpdateBuildingApiResponse =
  /** status 200 Item updated */ BuildingResponse;
export type UpdateBuildingApiArg = {
  /** Id of the requested building */
  buildingId: string;
  building: Building;
};
export type SearchBuildingFloorsApiResponse =
  /** status 200 Results matching criteria */ FloorResponseList;
export type SearchBuildingFloorsApiArg = {
  /** Id of the requested building */
  buildingId: string;
  /** used to scroll through the data */
  bookmark?: number | null;
  /** maximum number of records to return (<= 100) */
  limit?: number | null;
};
export type SearchBuildingAssetsApiResponse =
  /** status 200 Results matching criteria */ AssetResponseList;
export type SearchBuildingAssetsApiArg = {
  /** Id of the requested building */
  buildingId: string;
  /** used to scroll through the data */
  bookmark?: number | null;
  /** maximum number of records to return (<= 100) */
  limit?: number | null;
};
export type SearchBuildingDocumentsApiResponse =
  /** status 200 Results matching criteria */ DocumentResponseList;
export type SearchBuildingDocumentsApiArg = {
  /** Id of the requested building */
  buildingId: string;
  /** used to scroll through the data */
  bookmark?: number | null;
  /** maximum number of records to return (<= 100) */
  limit?: number | null;
};
export type SearchBuildingWorkOrdersApiResponse =
  /** status 200 Results matching criteria */ WorkOrderResponseList;
export type SearchBuildingWorkOrdersApiArg = {
  /** Id of the requested building */
  buildingId: string;
  /** used to scroll through the data */
  bookmark?: number | null;
  /** maximum number of records to return (<= 100) */
  limit?: number | null;
};
export type GetBuildingPolygonApiResponse =
  /** status 200 The requested polygon */ GisResponse;
export type GetBuildingPolygonApiArg = {
  /** Id of the requested building */
  buildingId: string;
};
export type UpdatePolygonApiResponse =
  /** status 200 The updated polygon */ GisResponse;
export type UpdatePolygonApiArg = {
  /** Id of the requested building */
  buildingId: string;
  gis: Gis;
};
export type GetBuildingContactPersonsApiResponse =
  /** status 200 The list of contact persons associated with building */ ContactPersonResponseList;
export type GetBuildingContactPersonsApiArg = {
  /** Id of the requested building */
  buildingId: string;
  /** used to scroll through the data */
  bookmark?: number | null;
  /** maximum number of records to return (<= 100) */
  limit?: number | null;
};
export type PostContactPersonsApiResponse =
  /** status 201 A list of new contact persons */ ContactPersonResponseList;
export type PostContactPersonsApiArg = {
  /** Id of the requested building */
  buildingId: string;
  body: {
    items?: ContactPerson[];
  };
};
export type SearchLotApiResponse =
  /** status 200 Lots matching the search criteria */ LotResponseList;
export type SearchLotApiArg = {
  /** used to scroll through the data */
  bookmark?: number | null;
  /** maximum number of records to return (<= 100) */
  limit?: number | null;
};
export type AddLotApiResponse = /** status 201 New lot created */ LotResponse;
export type AddLotApiArg = {
  lot: Lot;
};
export type GetLotApiResponse =
  /** status 200 The requested building */ LotResponse;
export type GetLotApiArg = {
  /** Id of the requested lot */
  lotId: string;
};
export type UpdateLotApiResponse = /** status 200 Item updated */ LotResponse;
export type UpdateLotApiArg = {
  /** Id of the requested lot */
  lotId: string;
  lot: Lot;
};
export type GetLotPolygonApiResponse =
  /** status 200 Results matching criteria */ GisResponse;
export type GetLotPolygonApiArg = {
  /** Id of the requested lot */
  lotId: string;
};
export type AddPolygonApiResponse =
  /** status 200 The updated polygon */ GisResponse;
export type AddPolygonApiArg = {
  /** Id of the requested lot */
  lotId: string;
  gis: Gis;
};
export type GetAllFloorsApiResponse =
  /** status 200 Results matching criteria */ FloorResponseList;
export type GetAllFloorsApiArg = {
  /** used to scroll through the data */
  bookmark?: number | null;
  /** maximum number of records to return (<= 100) */
  limit?: number | null;
};
export type AddFloorApiResponse =
  /** status 201 New floor created */ FloorResponse;
export type AddFloorApiArg = {
  floor: Floor;
};
export type GetFloorApiResponse =
  /** status 200 The requested floor */ FloorResponse;
export type GetFloorApiArg = {
  /** Id of the requested floor */
  floorId: string;
};
export type UpdateFloorApiResponse =
  /** status 200 Item updated */ FloorResponse;
export type UpdateFloorApiArg = {
  /** Id of the requested floor */
  floorId: string;
  /** the values to update */
  floor: Floor;
};
export type SearchFloorRoomsApiResponse =
  /** status 200 Results matching criteria */ RoomResponseList;
export type SearchFloorRoomsApiArg = {
  /** Id of the requested floor */
  floorId: string;
  /** used to scroll through the data */
  bookmark?: number | null;
  /** maximum number of records to return (<= 100) */
  limit?: number | null;
};
export type SearchRoomApiResponse =
  /** status 200 Results matching criteria */ RoomResponseList;
export type SearchRoomApiArg = {
  /** used to scroll through the data */
  bookmark?: number | null;
  /** maximum number of records to return (<= 100) */
  limit?: number | null;
};
export type GetRoomApiResponse =
  /** status 200 The requested room */ RoomResponse;
export type GetRoomApiArg = {
  /** Id of the requested room */
  roomId: string;
};
export type UpdateRoomApiResponse = /** status 200 Item updated */ RoomResponse;
export type UpdateRoomApiArg = {
  /** Id of the requested room */
  roomId: string;
  /** the values to update */
  room: Room;
};
export type GetRoomPolygonApiResponse =
  /** status 200 The requested polygon */ RoomPolygonResponse;
export type GetRoomPolygonApiArg = {
  /** Id of the requested room */
  roomId: string;
};
export type SearchDocumentApiResponse =
  /** status 200 Results matching criteria */ DocumentResponseList;
export type SearchDocumentApiArg = {
  /** used to scroll through the data */
  bookmark?: number | null;
  /** maximum number of records to return (<= 100) */
  limit?: number | null;
};
export type CreateDocumentApiResponse =
  /** status 201 Document created */ DocumentResponse;
export type CreateDocumentApiArg = {
  /** Id of the file upload session. Used to link the uploaded files with the objects in the system */
  uploadSessionId: string;
  document: Document;
};
export type GetDocumentApiResponse =
  /** status 200 The requested document */ DocumentResponse;
export type GetDocumentApiArg = {
  /** Id of the requested document */
  documentId: string;
};
export type UpdateDocumentApiResponse =
  /** status 200 Item updated */ DocumentResponse;
export type UpdateDocumentApiArg = {
  /** Id of the requested document */
  documentId: string;
  /** Id of the upload session containing new version of a document file. */
  uploadSessionIdQuery?: string;
  /** the values to update */
  document: Document;
};
export type GetBinaryDocumentApiResponse =
  /** status 200 The requested ressource */ FileLinkResponse;
export type GetBinaryDocumentApiArg = {
  /** Id of the requested document */
  documentId: string;
};
export type GetBinaryFileDocumentApiResponse =
  /** status 200 The requested ressource */ {
    /** bytearray with the actual file data */
    data?: Blob;
  };
export type GetBinaryFileDocumentApiArg = {
  /** Id of the requested document */
  documentId: string;
};
export type CreateUploadSessionApiResponse =
  /** status 200 Session retrieved */ FileUploadSessionResponse;
export type CreateUploadSessionApiArg = void;
export type UploadFileApiResponse =
  /** status 201 Upload successful */ Response;
export type UploadFileApiArg = {
  /** Id of the file upload session. Used to link the uploaded files with the objects in the system */
  uploadSessionId: string;
  /** Filename with extension. */
  'X-File-Name': string;
  body: Blob;
};
export type UploadFilePartApiResponse =
  /** status 201 Upload successful */ Response;
export type UploadFilePartApiArg = {
  /** Id of the file upload session. Used to link the uploaded files with the objects in the system */
  uploadSessionId: string;
  /** Filename with extension. */
  'X-File-Name': string;
  /** Defines the range of the chunk in the complete file in the same format as the Content-Range header.   Example: `bytes 0-999/10000`
   */
  'X-Upload-Range': string;
  body: Blob;
};
export type SearchAssetApiResponse =
  /** status 200 Results matching criteria */ AssetResponseList;
export type SearchAssetApiArg = {
  /** used to scroll through the data */
  bookmark?: number | null;
  /** maximum number of records to return (<= 100) */
  limit?: number | null;
};
export type AddAssetApiResponse =
  /** status 201 New asset created */ AssetResponse;
export type AddAssetApiArg = {
  asset: Asset;
};
export type GetAssetApiResponse =
  /** status 200 The requested asset */ AssetResponse;
export type GetAssetApiArg = {
  /** Id of the requested asset */
  assetId: string;
};
export type UpdateAssetApiResponse =
  /** status 200 Item updated */ AssetResponse;
export type UpdateAssetApiArg = {
  /** Id of the requested asset */
  assetId: string;
  /** the values to update */
  asset: Asset;
};
export type SearchSubAssetsApiResponse =
  /** status 200 Results matching criteria */ AssetResponseList;
export type SearchSubAssetsApiArg = {
  /** Id of the requested asset */
  assetId: string;
  /** used to scroll through the data */
  bookmark?: number | null;
  /** maximum number of records to return (<= 100) */
  limit?: number | null;
};
export type SearchAssetDocumentsApiResponse =
  /** status 200 Results matching criteria */ DocumentResponseList;
export type SearchAssetDocumentsApiArg = {
  /** Id of the requested asset */
  assetId: string;
  /** used to scroll through the data */
  bookmark?: number | null;
  /** maximum number of records to return (<= 100) */
  limit?: number | null;
};
export type SearchAssetWorkOrdersApiResponse =
  /** status 200 Results matching criteria */ WorkOrderResponseList;
export type SearchAssetWorkOrdersApiArg = {
  /** Id of the requested asset */
  assetId: string;
  /** used to scroll through the data */
  bookmark?: number | null;
  /** maximum number of records to return (<= 100) */
  limit?: number | null;
};
export type SearchAssetPhotosApiResponse =
  /** status 200 Results matching criteria */ PhotoResponseList;
export type SearchAssetPhotosApiArg = {
  /** Id of the requested asset */
  assetId: string;
  /** used to scroll through the data */
  bookmark?: number | null;
  /** maximum number of records to return (<= 100) */
  limit?: number | null;
};
export type SearchClassificationApiResponse =
  /** status 200 Results matching criteria */ ClassificationResponseList;
export type SearchClassificationApiArg = {
  /** used to scroll through the data */
  bookmark?: number | null;
  /** maximum number of records to return (<= 100) */
  limit?: number | null;
};
export type SearchWorkOrderApiResponse =
  /** status 200 Results matching criteria */ WorkOrderResponseList;
export type SearchWorkOrderApiArg = {
  /** used to scroll through the data */
  bookmark?: number | null;
  /** maximum number of records to return (<= 100) */
  limit?: number | null;
};
export type CreateWorkOrderApiResponse =
  /** status 201 WorkOrder created */ WorkOrderResponse;
export type CreateWorkOrderApiArg = {
  /** The values to update. */
  workOrder: WorkOrder;
};
export type GetWorkOrderApiResponse =
  /** status 200 The requested WorkOrder */ WorkOrderResponse;
export type GetWorkOrderApiArg = {
  /** Id of the requested workorder */
  workOrderId: string;
};
export type UpdateWorkOrderApiResponse =
  /** status 200 Item updated */ WorkOrderResponse;
export type UpdateWorkOrderApiArg = {
  /** Id of the requested workorder */
  workOrderId: string;
  /** the values to update */
  workOrder: WorkOrder;
};
export type SearchWorkOrderDocumentsApiResponse =
  /** status 200 Results matching criteria */ DocumentResponseList;
export type SearchWorkOrderDocumentsApiArg = {
  /** Id of the requested workorder */
  workOrderId: string;
  /** used to scroll through the data */
  bookmark?: number | null;
  /** maximum number of records to return (<= 100) */
  limit?: number | null;
};
export type CreateDocumentOnWorkOrderApiResponse =
  /** status 201 New document attached to the work order */ DocumentResponse;
export type CreateDocumentOnWorkOrderApiArg = {
  /** Id of the file upload session. Used to link the uploaded files with the objects in the system */
  uploadSessionId: string;
  /** Id of the requested workorder */
  workOrderId: string;
  document: Document;
};
export type SearchWorkOrderPhotosApiResponse =
  /** status 200 Results matching criteria */ PhotoResponseList;
export type SearchWorkOrderPhotosApiArg = {
  /** Id of the requested workorder */
  workOrderId: string;
  /** used to scroll through the data */
  bookmark?: number | null;
  /** maximum number of records to return (<= 100) */
  limit?: number | null;
};
export type CreatePhotoOnWorkOrderApiResponse =
  /** status 201 New photo attached to the work order */ PhotoResponse;
export type CreatePhotoOnWorkOrderApiArg = {
  /** Id of the file upload session. Used to link the uploaded files with the objects in the system */
  uploadSessionId: string;
  /** Id of the requested workorder */
  workOrderId: string;
  photo: Photo;
};
export type SearchWorkOrderHistoryApiResponse =
  /** status 200 Results matching criteria */ HistoryResponseList;
export type SearchWorkOrderHistoryApiArg = {
  /** Id of the requested workorder */
  workOrderId: string;
  /** used to scroll through the data */
  bookmark?: number | null;
  /** maximum number of records to return (<= 100) */
  limit?: number | null;
};
export type SearchWorkOrderTimeRegistrationsApiResponse =
  /** status 200 Results matching criteria */ TimeRegistrationResponseList;
export type SearchWorkOrderTimeRegistrationsApiArg = {
  /** Id of the requested workorder */
  workOrderId: string;
  /** used to scroll through the data */
  bookmark?: number | null;
  /** maximum number of records to return (<= 100) */
  limit?: number | null;
};
export type SearchWorkOrderTemplatesApiResponse =
  /** status 200 Results matching criteria */ TemplateResponseList;
export type SearchWorkOrderTemplatesApiArg = {
  /** used to scroll through the data */
  bookmark?: number | null;
  /** maximum number of records to return (<= 100) */
  limit?: number | null;
};
export type SearchWorkOrderPrioritiesApiResponse =
  /** status 200 Results matching criteria */ PriorityResponseList;
export type SearchWorkOrderPrioritiesApiArg = {
  /** used to scroll through the data */
  bookmark?: number | null;
  /** maximum number of records to return (<= 100) */
  limit?: number | null;
};
export type SearchTeamsApiResponse =
  /** status 200 Results matching criteria */ TeamResponseList;
export type SearchTeamsApiArg = {
  /** used to scroll through the data */
  bookmark?: number | null;
  /** maximum number of records to return (<= 100) */
  limit?: number | null;
};
export type SearchWorkOrderStatusesApiResponse =
  /** status 200 Results matching criteria */ WorkOrderStatusResponseList;
export type SearchWorkOrderStatusesApiArg = {
  /** used to scroll through the data */
  bookmark?: number | null;
  /** maximum number of records to return (<= 100) */
  limit?: number | null;
};
export type SearchWorkOrderTimeAccountsApiResponse =
  /** status 200 Results matching criteria */ TimeAccountResponseList;
export type SearchWorkOrderTimeAccountsApiArg = {
  /** used to scroll through the data */
  bookmark?: number | null;
  /** maximum number of records to return (<= 100) */
  limit?: number | null;
};
export type SearchExternalWorkOrderApiResponse =
  /** status 200 Results matching criteria */ WorkOrderExternalResponseList;
export type SearchExternalWorkOrderApiArg = {
  /** used to scroll through the data */
  bookmark?: number | null;
  /** maximum number of records to return (<= 100) */
  limit?: number | null;
};
export type GetExternalWorkOrderApiResponse =
  /** status 200 The requested WorkOrder */ WorkOrderExternalResponse;
export type GetExternalWorkOrderApiArg = {
  /** Id of the requested workorder */
  workOrderId: string;
};
export type UpdateExternalWorkOrderApiResponse =
  /** status 200 Item updated */ WorkOrderExternalResponse;
export type UpdateExternalWorkOrderApiArg = {
  /** Id of the requested workorder */
  workOrderId: string;
  /** the values to update */
  workOrderExternal: WorkOrderExternal;
};
export type SearchExternalWorkOrderHistoryApiResponse =
  /** status 200 Results matching criteria */ HistoryResponseList;
export type SearchExternalWorkOrderHistoryApiArg = {
  /** Id of the requested workorder */
  workOrderId: string;
  /** used to scroll through the data */
  bookmark?: number | null;
  /** maximum number of records to return (<= 100) */
  limit?: number | null;
};
export type CreateNoteApiResponse =
  /** status 201 Note created */ MessageResponse;
export type CreateNoteApiArg = {
  /** Id of the requested workorder */
  workOrderId: string;
  /** The values to update. */
  message: Message;
};
export type SendMessageApiResponse =
  /** status 201 Message sent */ MessageResponse;
export type SendMessageApiArg = {
  /** Id of the requested workorder */
  workOrderId: string;
  /** The values to update. */
  message: Message;
};
export type AddInformationApiResponse =
  /** status 201 Information added */ AddInformationResponse;
export type AddInformationApiArg = {
  /** Id of the requested workorder */
  workOrderId: string;
  /** The values to update. */
  addInformation: AddInformation;
};
export type AddTimeUsageApiResponse =
  /** status 200 Time usage added */ TimeUsageResponse;
export type AddTimeUsageApiArg = {
  /** Id of the requested workorder */
  workOrderId: string;
  /** The values to update. */
  timeUsage: TimeUsage;
};
export type ConfirmWorkOrderExternalApiResponse =
  /** status 200 Work order has been marked as confirmed */ ConfirmResponse;
export type ConfirmWorkOrderExternalApiArg = {
  /** Id of the requested workorder */
  workOrderId: string;
  /** The values to update. */
  confirm: Confirm;
};
export type RejectWorkOrderExternalApiResponse = unknown;
export type RejectWorkOrderExternalApiArg = {
  /** Id of the requested workorder */
  workOrderId: string;
};
export type CompleteWorkOrderExternalApiResponse = unknown;
export type CompleteWorkOrderExternalApiArg = {
  /** Id of the requested workorder */
  workOrderId: string;
};
export type SearchExternalWorkOrderStatusesApiResponse =
  /** status 200 Results matching criteria */ WorkOrderStatusResponseList;
export type SearchExternalWorkOrderStatusesApiArg = {
  /** used to scroll through the data */
  bookmark?: number | null;
  /** maximum number of records to return (<= 100) */
  limit?: number | null;
};
export type SearchTicketApiResponse =
  /** status 200 Results matching criteria */ TicketResponseList;
export type SearchTicketApiArg = {
  /** used to scroll through the data */
  bookmark?: number | null;
  /** maximum number of records to return (<= 100) */
  limit?: number | null;
};
export type CreateTicketApiResponse =
  /** status 201 Ticket created */ TicketResponse;
export type CreateTicketApiArg = {
  /** The values to update. */
  ticket: Ticket;
};
export type GetTicketApiResponse =
  /** status 200 The requested Ticket */ TicketResponse;
export type GetTicketApiArg = {
  /** Id of the requested ticket */
  ticketId: string;
};
export type UpdateTicketApiResponse =
  /** status 200 Item updated */ TicketResponse;
export type UpdateTicketApiArg = {
  /** Id of the requested ticket */
  ticketId: string;
  /** the values to update */
  ticket: Ticket;
};
export type SearchTicketHistoryApiResponse =
  /** status 200 Results matching criteria */ HistoryResponseList;
export type SearchTicketHistoryApiArg = {
  /** Id of the requested ticket */
  ticketId: string;
  /** used to scroll through the data */
  bookmark?: number | null;
  /** maximum number of records to return (<= 100) */
  limit?: number | null;
};
export type SearchTicketPhotosApiResponse =
  /** status 200 Results matching criteria */ PhotoResponseList;
export type SearchTicketPhotosApiArg = {
  /** Id of the requested ticket */
  ticketId: string;
  /** used to scroll through the data */
  bookmark?: number | null;
  /** maximum number of records to return (<= 100) */
  limit?: number | null;
};
export type SearchTicketTopicsApiResponse =
  /** status 200 Results matching criteria */ TopicResponseList;
export type SearchTicketTopicsApiArg = {
  /** used to scroll through the data */
  bookmark?: number | null;
  /** maximum number of records to return (<= 100) */
  limit?: number | null;
};
export type SearchTicketTopicBuildingsApiResponse =
  /** status 200 Results matching criteria */ BuildingResponseList;
export type SearchTicketTopicBuildingsApiArg = {
  /** Id of the requested topic */
  topicId: string;
  /** used to scroll through the data */
  bookmark?: number | null;
  /** maximum number of records to return (<= 100) */
  limit?: number | null;
};
export type SearchTicketTopicClassificationsApiResponse =
  /** status 200 Results matching criteria */ ClassificationResponseList;
export type SearchTicketTopicClassificationsApiArg = {
  /** Id of the requested topic */
  topicId: string;
  /** used to scroll through the data */
  bookmark?: number | null;
  /** maximum number of records to return (<= 100) */
  limit?: number | null;
};
export type SearchTicketTopicLotsApiResponse =
  /** status 200 Results matching criteria */ LotResponseList;
export type SearchTicketTopicLotsApiArg = {
  /** Id of the requested topic */
  topicId: string;
  /** used to scroll through the data */
  bookmark?: number | null;
  /** maximum number of records to return (<= 100) */
  limit?: number | null;
};
export type SearchTicketTopicRoomTypesApiResponse =
  /** status 200 Results matching criteria */ RoomTypeResponseList;
export type SearchTicketTopicRoomTypesApiArg = {
  /** Id of the requested topic */
  topicId: string;
  /** used to scroll through the data */
  bookmark?: number | null;
  /** maximum number of records to return (<= 100) */
  limit?: number | null;
};
export type SearchStatusesApiResponse =
  /** status 200 Results matching criteria */ TicketStatusResponseList;
export type SearchStatusesApiArg = {
  /** used to scroll through the data */
  bookmark?: number | null;
  /** maximum number of records to return (<= 100) */
  limit?: number | null;
};
export type SendMessagePhotoApiResponse =
  /** status 201 Messsage sent */ Response;
export type SendMessagePhotoApiArg = {
  /** Id of the requested ticket */
  ticketId: string;
  /** Messsage sent */
  messagePhoto: MessagePhoto;
};
export type SearchCompanyApiResponse =
  /** status 200 Results matching criteria */ CompanyResponseList;
export type SearchCompanyApiArg = {
  /** used to scroll through the data */
  bookmark?: number | null;
  /** maximum number of records to return (<= 100) */
  limit?: number | null;
};
export type GetCompanyApiResponse =
  /** status 200 The requested Company */ CompanyResponse;
export type GetCompanyApiArg = {
  /** Id of the requested company */
  companyId: string;
};
export type SearchCompanyWorkOrdersApiResponse =
  /** status 200 Results matching criteria */ WorkOrderResponseList;
export type SearchCompanyWorkOrdersApiArg = {
  /** Id of the requested company */
  companyId: string;
  /** used to scroll through the data */
  bookmark?: number | null;
  /** maximum number of records to return (<= 100) */
  limit?: number | null;
};
export type SearchProductApiResponse =
  /** status 200 Results matching criteria */ ProductResponseList;
export type SearchProductApiArg = {
  /** used to scroll through the data */
  bookmark?: number | null;
  /** maximum number of records to return (<= 100) */
  limit?: number | null;
};
export type CreateProductApiResponse =
  /** status 201 Product created */ ProductResponse;
export type CreateProductApiArg = {
  /** The values to update. */
  product: Product;
};
export type GetProductApiResponse =
  /** status 200 The requested Product */ ProductResponse;
export type GetProductApiArg = {
  /** Id of the requested product */
  productId: string;
};
export type UpdateProductApiResponse =
  /** status 200 Item updated */ ProductResponse;
export type UpdateProductApiArg = {
  /** Id of the requested product */
  productId: string;
  /** the values to update */
  product: Product;
};
export type SearchProductsDocumentsApiResponse =
  /** status 200 Results matching criteria */ DocumentResponseList;
export type SearchProductsDocumentsApiArg = {
  /** Id of the requested product */
  productId: string;
  /** used to scroll through the data */
  bookmark?: number | null;
  /** maximum number of records to return (<= 100) */
  limit?: number | null;
};
export type SearchInvoiceApiResponse =
  /** status 200 Results matching criteria */ InvoiceResponseList;
export type SearchInvoiceApiArg = {
  /** used to scroll through the data */
  bookmark?: number | null;
  /** maximum number of records to return (<= 100) */
  limit?: number | null;
};
export type CreateInvoiceApiResponse =
  /** status 201 Invoice created */ InvoiceResponse;
export type CreateInvoiceApiArg = {
  /** The values to update. */
  invoice: Invoice;
};
export type GetInvoiceApiResponse =
  /** status 200 The requested Invoice */ InvoiceResponse;
export type GetInvoiceApiArg = {
  /** Id of the requested invoice */
  invoiceId: string;
};
export type UpdateInvoiceApiResponse =
  /** status 200 Item updated */ InvoiceResponse;
export type UpdateInvoiceApiArg = {
  /** Id of the requested invoice */
  invoiceId: string;
  /** the values to update */
  invoice: Invoice;
};
export type SearchInvoicesDocumentsApiResponse =
  /** status 200 Results matching criteria */ DocumentResponseList;
export type SearchInvoicesDocumentsApiArg = {
  /** Id of the requested invoice */
  invoiceId: string;
  /** used to scroll through the data */
  bookmark?: number | null;
  /** maximum number of records to return (<= 100) */
  limit?: number | null;
};
export type CreateDocumentOnInvoiceApiResponse =
  /** status 201 New document attached to an invoice */ DocumentResponse;
export type CreateDocumentOnInvoiceApiArg = {
  /** Id of the file upload session. Used to link the uploaded files with the objects in the system */
  uploadSessionId: string;
  /** Id of the requested invoice */
  invoiceId: string;
  document: Document;
};
export type SearchInvoiceStatusesApiResponse =
  /** status 200 Results matching criteria */ InvoiceStatusResponseList;
export type SearchInvoiceStatusesApiArg = {
  /** used to scroll through the data */
  bookmark?: number | null;
  /** maximum number of records to return (<= 100) */
  limit?: number | null;
};
export type SearchChecklistApiResponse =
  /** status 200 Results matching criteria */ ChecklistResponseList;
export type SearchChecklistApiArg = {
  /** used to scroll through the data */
  bookmark?: number | null;
  /** maximum number of records to return (<= 100) */
  limit?: number | null;
};
export type GetChecklistApiResponse =
  /** status 200 The requested Checklist */ ChecklistResponse;
export type GetChecklistApiArg = {
  /** Id of the requested checklist */
  checklistId: string;
};
export type SearchChecklistAttachmentApiResponse =
  /** status 200 Results matching criteria */ ChecklistAttachmentResponseList;
export type SearchChecklistAttachmentApiArg = {
  /** Id of the requested checklist */
  checklistId: string;
  /** used to scroll through the data */
  bookmark?: number | null;
  /** maximum number of records to return (<= 100) */
  limit?: number | null;
};
export type SearchZonesApiResponse =
  /** status 200 Results matching criteria */ ZoneResponseList;
export type SearchZonesApiArg = {
  /** used to scroll through the data */
  bookmark?: number | null;
  /** maximum number of records to return (<= 100) */
  limit?: number | null;
};
export type GetZoneApiResponse =
  /** status 200 The requested Zone */ ZoneResponse;
export type GetZoneApiArg = {
  /** Id of the requested zone */
  zoneId: string;
};
export type SearchZoneDocumentsApiResponse =
  /** status 200 Results matching criteria */ DocumentResponseList;
export type SearchZoneDocumentsApiArg = {
  /** Id of the requested zone */
  zoneId: string;
  /** used to scroll through the data */
  bookmark?: number | null;
  /** maximum number of records to return (<= 100) */
  limit?: number | null;
};
export type Link = {
  /** The list of enums is not final and may contain further values at later point */
  rel?: 'self' | 'parent' | 'child' | 'nextPage' | 'deep';
  /** The list of enums is not final and may contain further values at later point */
  method?: 'GET' | 'POST' | 'PATCH' | 'DELETE';
  /** Full hyperlink reference */
  href?: string;
};
export type LinkList = {
  /** ignored on POST and PATCH */
  links?: Link[];
};
export type Response = LinkList & {
  responseMessage?: string;
  date?: string;
};
export type Metadata = {
  totalItems?: number;
  limit?: number;
  bookmark?: string;
  nextBookmark?: string | null;
};
export type ListResponse = Response & {
  metadata?: Metadata;
};
export type LocationReference = {
  locationId?: string | null;
} | null;
export type Location =
  | (LinkList & {
      data?: {
        locationId?: string | null;
        name?: string | null;
        description?: string | null;
        parentLocationRef?: LocationReference;
      };
    })
  | null;
export type LocationResponseList =
  | (ListResponse & {
      items?: Location[] | null;
    })
  | null;
export type UserFieldValue = {
  text?: string | null;
  date?: string | null;
  number?: number | null;
  integer?: number | null;
  boolean?: boolean | null;
} | null;
export type UserDefinedField = {
  /** ignored on POST and PATCH */
  userDefinedFieldId?: string | null;
  /** ignored on POST and PATCH */
  name?: string | null;
  /** ignored on POST and PATCH */
  description?: string | null;
  values?: UserFieldValue[] | null;
} | null;
export type UserDefinedFieldsList = {
  links?: Link[] | null;
  items?: UserDefinedField[] | null;
} | null;
export type Estate =
  | (LinkList & {
      data?: {
        /** ignored on POST and PATCH */
        estateId?: string | null;
        name?: string | null;
        description?: string | null;
        locationRef?: LocationReference;
        /** ignored on POST and PATCH */
        lastChangeDate?: string | null;
        userDefinedFields?: UserDefinedFieldsList;
      };
    })
  | null;
export type EstateResponseList =
  | (ListResponse & {
      items?: Estate[] | null;
    })
  | null;
export type EstateResponse = Response & Estate;
export type EstateReference = {
  estateId?: string | null;
} | null;
export type Address = {
  road?: string | null;
  number?: string | null;
  zipCode?: string | null;
  city?: string | null;
} | null;
export type Building =
  | (LinkList & {
      data?: {
        /** ignored on POST and PATCH */
        buildingId?: string | null;
        name?: string | null;
        alternativeName?: string | null;
        estateRef?: EstateReference;
        address?: Address;
        owned?: boolean | null;
        label?: string | null;
        /** ignored on POST and PATCH */
        userRegion?: (string | null)[] | null;
        /** ignored on POST and PATCH if building has BIM based rooms */
        grossArea?: number | null;
        /** ignored on POST and PATCH if building has BIM based rooms */
        netArea?: number | null;
        /** ignored on POST and PATCH */
        lastChangeDate?: string | null;
        /** ignored on POST and PATCH */
        lastBimChangeDate?: string | null;
        userDefinedFields?: UserDefinedFieldsList;
      };
    })
  | null;
export type BuildingResponseList =
  | (ListResponse & {
      items?: Building[] | null;
    })
  | null;
export type Lot =
  | (LinkList & {
      data?: {
        /** ignored on POST and PATCH */
        lotId?: string | null;
        name?: string | null;
        alternativeName?: string | null;
        estateRef?: EstateReference;
        /** ignored on POST and PATCH */
        userRegion?: (string | null)[] | null;
        address?: Address;
        lastChangeDate?: string | null;
        label?: string | null;
        userDefinedFields?: UserDefinedFieldsList;
      };
    })
  | null;
export type LotResponseList =
  | (ListResponse & {
      items?: Lot[] | null;
    })
  | null;
export type BuildingResponse = Response & Building;
export type BuildingReference = {
  buildingId?: string | null;
} | null;
export type Floor =
  | (LinkList & {
      data?: {
        /** ignored on POST and PATCH */
        floorId?: string | null;
        name?: string | null;
        alternativeName?: string | null;
        /** ignored on POST and PATCH if floor has BIM based rooms */
        buildingRef?: BuildingReference;
        type?: string | null;
        height?: number | null;
        /** ignored on POST and PATCH if floor has BIM based rooms */
        grossArea?: number | null;
        /** ignored on POST and PATCH if floor has BIM based rooms */
        netArea?: number | null;
        /** ignored on POST and PATCH */
        lastChangeDate?: string | null;
        userDefinedFields?: UserDefinedFieldsList;
      };
    })
  | null;
export type FloorResponseList =
  | (ListResponse & {
      items?: Floor[] | null;
    })
  | null;
export type Classification = {
  data?: {
    classificationId?: string | null;
    /** ignored on POST and PATCH */
    classificationParentId?: string | null;
    /** ignored on POST and PATCH */
    name?: string | null;
    /** ignored on POST and PATCH */
    code?: string | null;
  };
} | null;
export type Coordinate = {
  lat?: number | null;
  lng?: number | null;
} | null;
export type LotReference = {
  lotId?: string | null;
} | null;
export type FloorReference = {
  floorId?: string | null;
} | null;
export type RoomReference = {
  roomId?: string | null;
} | null;
export type AssetReference = {
  assetId?: string | null;
} | null;
export type Placement = {
  description?: string | null;
  coordinates?: Coordinate[] | null;
  locationRefs?: LocationReference[] | null;
  estateRefs?: EstateReference[] | null;
  lotRefs?: LotReference[] | null;
  buildingRefs?: BuildingReference[] | null;
  floorRefs?: FloorReference[] | null;
  roomRefs?: RoomReference[] | null;
  assetRefs?: AssetReference[] | null;
} | null;
export type BimInstanceReference = {
  bimInstanceId?: string | null;
} | null;
export type ProductReference = {
  productId?: string | null;
} | null;
export type Asset =
  | (LinkList & {
      data?: {
        /** ignored on POST and PATCH */
        assetId?: string | null;
        name?: string | null;
        description?: string | null;
        /** ignored on POST and PATCH */
        disciplines?: (string | null)[] | null;
        classification?: Classification;
        placement?: Placement;
        bimInstanceRefs?: BimInstanceReference[] | null;
        /** ignored on POST and PATCH */
        label?: string | null;
        /** ignored on POST and PATCH */
        productRef?: ProductReference;
        /** ignored on POST */
        parentAssetRef?: AssetReference;
        /** ignored on POST and PATCH */
        lastChangeDate?: string | null;
        /** ignored on POST and PATCH */
        lastChangedBy?: string | null;
        /** ignored on POST and PATCH */
        createdDate?: string | null;
        /** ignored on POST and PATCH */
        createdBy?: string | null;
        /** ignored on POST and PATCH */
        qrCodes?: (string | null)[] | null;
        warrantyStartDate?: string | null;
        warrantyEndDate?: string | null;
        installationDate?: string | null;
        userDefinedFields?: UserDefinedFieldsList;
      };
    })
  | null;
export type AssetResponseList = ListResponse &
  ({
    items?: Asset[] | null;
  } | null);
export type ZoneReference = {
  zoneId?: string | null;
} | null;
export type Document =
  | (LinkList & {
      data?: {
        /** ignored on POST and PATCH */
        documentId?: string | null;
        assetRefs?: AssetReference[] | null;
        buildingRefs?: BuildingReference[] | null;
        estateRefs?: EstateReference[] | null;
        lotRefs?: LotReference[] | null;
        productRefs?: ProductReference[] | null;
        roomRefs?: RoomReference[] | null;
        zoneRefs?: ZoneReference[] | null;
        /** ignored on POST and PATCH */
        filename?: string | null;
        /** ignored on POST and PATCH */
        size?: string | null;
        /** ignored on POST and PATCH */
        version?: number | null;
        /** ignored on POST and PATCH */
        lastChangeDate?: string | null;
        /** ignored on POST and PATCH */
        uploadedBy?: string | null;
        /** ignored on POST and PATCH */
        uploadedDate?: string | null;
        userDefinedFields?: UserDefinedFieldsList;
      };
    })
  | null;
export type DocumentResponseList =
  | (ListResponse & {
      items?: Document[] | null;
    })
  | null;
export type WorkOrderReference = {
  workOrderId?: string | null;
} | null;
export type TemplateReference = {
  templateId?: string | null;
} | null;
export type TeamReference = {
  teamId?: string | null;
} | null;
export type PriorityReference = {
  priorityId?: string | null;
} | null;
export type CompanyReference = {
  companyId?: string | null;
} | null;
export type ChecklistReference = {
  checklistId?: string | null;
} | null;
export type WorkOrder =
  | (LinkList & {
      data?: {
        /** ignored on POST and PATCH */
        workOrderId?: string | null;
        /** ignored on POST and PATCH */
        number?: string | null;
        name?: string | null;
        /** ignored on POST and PATCH */
        status?: number | null;
        linkedWorkOrderRefs?: WorkOrderReference[] | null;
        templateRef?: TemplateReference;
        teamRef?: TeamReference;
        responsibleUserEmail?: string | null;
        description?: string | null;
        priorityRef?: PriorityReference;
        type?: string | null;
        placement?: Placement;
        deadlineDate?: string | null;
        startDate?: string | null;
        /** ignored on POST and PATCH */
        durationDays?: number | null;
        /** ignored on POST and PATCH */
        createdDate?: string | null;
        /** ignored on POST and PATCH */
        lastChangeDate?: string | null;
        /** ignored on POST and PATCH */
        closedDate?: string | null;
        /** requires valid accountName and accountNumber; on PATCH also requires work order has no cost items */
        expectedCost?: number | null;
        /** ignored on POST and PATCH */
        expectedExecutionDate?: string | null;
        /** ignored on POST and PATCH */
        accountName?: string | null;
        /** ignored on POST and PATCH */
        accountNumber?: string | null;
        /** ignored on POST and PATCH */
        companyRef?: CompanyReference;
        isStatutory?: boolean | null;
        hasWarranty?: boolean | null;
        isEconomyClosed?: boolean | null;
        /** ignored on POST and PATCH */
        checklistRefs?: ChecklistReference[] | null;
        /** ignored on POST and PATCH */
        hoursRegistered?: number | null;
        userDefinedFields?: UserDefinedFieldsList;
      };
    })
  | null;
export type WorkOrderResponseList =
  | (ListResponse & {
      items?: WorkOrder[] | null;
    })
  | null;
export type GisPolygon = {
  data?: {
    coordinates?: Coordinate[] | null;
  };
} | null;
export type Gis =
  | (LinkList & {
      data?: {
        OuterPolygon?: GisPolygon;
        InnerPolygons?: GisPolygon[] | null;
      };
    })
  | null;
export type GisResponse = Response & Gis;
export type ContactPerson = {
  data?: {
    contactPersonId?: string | null;
    name?: string | null;
    email?: string | null;
    phoneNo?: string | null;
    description?: string | null;
  };
} | null;
export type ContactPersonResponseList =
  | (ListResponse & {
      items?: ContactPerson[] | null;
    })
  | null;
export type LotResponse = Response & Lot;
export type FloorResponse = Response & Floor;
export type Room =
  | (LinkList & {
      data?: {
        /** ignored on POST and PATCH */
        roomId?: string | null;
        /** ignored on POST and PATCH */
        floorRef?: FloorReference;
        /** ignored on POST and PATCH */
        calculatedGrossArea?: number | null;
        /** ignored on POST and PATCH */
        netArea?: number | null;
        /** ignored on POST and PATCH */
        lastChangeDate?: string | null;
        userDefinedFields?: UserDefinedFieldsList;
      };
    })
  | null;
export type RoomResponseList =
  | (ListResponse & {
      items?: Room[] | null;
    })
  | null;
export type RoomResponse = Response & Room;
export type Point = {
  x?: number;
  y?: number;
} | null;
export type Polygon = {
  data?: {
    coordinates?: Point[];
  };
} | null;
export type RoomPolygon =
  | (LinkList & {
      data?: {
        OuterPolygon?: Polygon;
        InnerPolygons?: Polygon[] | null;
      };
    })
  | null;
export type RoomPolygonResponse = Response & RoomPolygon;
export type DocumentResponse = Response & Document;
export type FileLink =
  | (LinkList & {
      data?: {
        documentId?: string | null;
        filename?: string | null;
        size?: string | null;
        url?: string | null;
      };
    })
  | null;
export type FileLinkResponse = Response & FileLink;
export type FileUploadSession =
  | (LinkList & {
      data?: {
        sessionId?: string | null;
      };
    })
  | null;
export type FileUploadSessionResponse = Response & FileUploadSession;
export type AssetResponse = Response & Asset;
export type Photo =
  | (LinkList & {
      data?: {
        photoId?: string | null;
        name?: string;
        url?: string | null;
      };
    })
  | null;
export type PhotoResponseList =
  | (ListResponse & {
      items?: Photo[] | null;
    })
  | null;
export type ClassificationResponseList =
  | (ListResponse & {
      items?: Classification[] | null;
    })
  | null;
export type WorkOrderResponse = Response & WorkOrder;
export type PhotoResponse = Response & Photo;
export type HistoryEntryLine = {
  title?: string | null;
  value?: string | null;
} | null;
export type HistoryAttachment = {
  fileName?: string | null;
  fileType?: string | null;
  requestUrl?: string | null;
} | null;
export type HistoryEntry =
  | (LinkList & {
      data?: {
        title?: string | null;
        date?: string | null;
        lines?: HistoryEntryLine[] | null;
        downloadRequestUrls?: HistoryAttachment[] | null;
      };
    })
  | null;
export type HistoryResponseList =
  | (ListResponse & {
      items?: HistoryEntry[] | null;
    })
  | null;
export type TimeRegistrationEntry = {
  timeRegistrationId?: string | null;
  description?: string | null;
  minutesRegistered?: string | null;
} | null;
export type TimeRegistrationResponseList =
  | (ListResponse & {
      items?: TimeRegistrationEntry[] | null;
    })
  | null;
export type Template = {
  templateId?: string | null;
  name?: string | null;
} | null;
export type TemplateResponseList =
  | (ListResponse & {
      items?: Template[] | null;
    })
  | null;
export type Priority = {
  priorityId?: string | null;
  name?: string | null;
  order?: string | null;
  default?: boolean | null;
} | null;
export type PriorityResponseList =
  | (ListResponse & {
      items?: Priority[] | null;
    })
  | null;
export type Team = {
  teamId?: string | null;
  name?: string | null;
  group?: string | null;
} | null;
export type TeamResponseList =
  | (ListResponse & {
      items?: Team[] | null;
    })
  | null;
export type WorkOrderStatus = {
  workOrderStatusId?: string | null;
  name?: string | null;
} | null;
export type WorkOrderStatusResponseList =
  | (ListResponse & {
      items?: WorkOrderStatus[] | null;
    })
  | null;
export type TimeAccount = {
  timeAccountId?: string | null;
  name?: string | null;
  description?: string | null;
} | null;
export type TimeAccountResponseList =
  | (ListResponse & {
      items?: TimeAccount[] | null;
    })
  | null;
export type TicketReference = {
  ticketId?: string;
} | null;
export type TopicRef = {
  topicId?: string | null;
};
export type WorkOrderExternal =
  | (LinkList & {
      data?: {
        /** ignored on POST and PATCH */
        workOrderId?: string | null;
        /** ignored on POST and PATCH */
        number?: string | null;
        /** ignored on PATCH */
        name?: string | null;
        /** ignored on PATCH */
        status?: number | null;
        /** ignored on PATCH */
        description?: string | null;
        /** ignored on PATCH */
        responsibleUserEmail?: string | null;
        /** ignored on PATCH */
        type?: string | null;
        /** ignored on PATCH */
        teamRef?: TeamReference;
        /** ignored on PATCH */
        priorityRef?: PriorityReference;
        /** ignored on PATCH */
        placement?: Placement;
        /** ignored on PATCH */
        ticketRefs?: TicketReference[] | null;
        /** ignored on PATCH */
        addresses?: (string | null)[] | null;
        /** ignored on PATCH */
        alternativeBuildingNames?: (string | null)[] | null;
        /** ignored on PATCH */
        contactPersonEmail?: string | null;
        /** ignored on PATCH */
        contactPersonName?: string | null;
        /** ignored on PATCH */
        contactPersonPhone?: string | null;
        /** ignored on POST and PATCH */
        lastChangeDate?: string | null;
        /** ignored on PATCH */
        startDate?: string | null;
        /** ignored on PATCH */
        deadlineDate?: string | null;
        /** ignored on PATCH */
        closedDate?: string | null;
        /** ignored on PATCH */
        executionDate?: string | null;
        expectedExecutionDate?: string | null;
        /** ignored on PATCH */
        durationDays?: number | null;
        expectedCost?: number | null;
        topicRef?: TopicRef;
        /** ignored on POST and PATCH */
        checklistRefs?: ChecklistReference[] | null;
        userDefinedFields?: UserDefinedFieldsList;
      };
    })
  | null;
export type WorkOrderExternalResponseList =
  | (ListResponse & {
      items?: WorkOrderExternal[] | null;
    })
  | null;
export type WorkOrderExternalResponse = Response & WorkOrderExternal;
export type Message = {
  data?: {
    message?: string | null;
  };
} | null;
export type MessageResponse = Response & Message;
export type AddInformation = {
  data?: {
    message?: string | null;
  };
} | null;
export type AddInformationResponse = Response & AddInformation;
export type TimeUsage = {
  data?: {
    minutes?: number | null;
  };
} | null;
export type TimeUsageResponse = Response & TimeUsage;
export type Confirm = {
  data?: {
    expectedExecutionDate?: string | null;
    expectedCost?: number | null;
  };
} | null;
export type ConfirmResponse = Response & Confirm;
export type Topic = {
  topicId?: string | null;
  /** ignored on POST and PATCH */
  name?: string | null;
} | null;
export type Ticket =
  | (LinkList & {
      data?: {
        /** ignored on POST and PATCH */
        ticketId?: string | null;
        /** ignored on POST and PATCH */
        number?: string | null;
        reporterEmail?: string | null;
        reporterPhoneNo?: string | null;
        reporterName?: string | null;
        placement?: Placement;
        topic?: Topic;
        description?: string;
        status?: number | null;
        /** ignored on POST and PATCH */
        responsibleUserEmail?: string | null;
        /** ignored on POST and PATCH */
        teamRef?: TeamReference;
        /** ignored on POST and PATCH */
        helpdeskId?: string | null;
        /** ignored on POST and PATCH */
        lastChangeDate?: string | null;
        /** ignored on POST and PATCH */
        createdDate?: string | null;
        userDefinedFields?: UserDefinedFieldsList;
      };
    })
  | null;
export type TicketResponseList =
  | (ListResponse & {
      items?: Ticket[] | null;
    })
  | null;
export type TicketResponse = Response & Ticket;
export type TopicResponseList =
  | (ListResponse & {
      items?: Topic[] | null;
    })
  | null;
export type RoomType = {
  data?: {
    name?: string | null;
  };
} | null;
export type RoomTypeResponseList =
  | (ListResponse & {
      items?: RoomType[] | null;
    })
  | null;
export type TicketStatus = {
  ticketStatusId?: string | null;
  name?: string | null;
} | null;
export type TicketStatusResponseList =
  | (ListResponse & {
      items?: TicketStatus[] | null;
    })
  | null;
export type MessagePhoto = {
  data?: {
    message?: string;
    uploadSessionIds?: string[];
  };
} | null;
export type Company =
  | (LinkList & {
      data?: {
        companyId?: string | null;
        name?: string | null;
        description?: string | null;
        organisationId?: string | null;
        isActive?: boolean | null;
        address?: Address;
        phoneNo?: string | null;
        email?: string | null;
        disciplines?: (string | null)[] | null;
        companyTypes?: (string | null)[] | null;
        userDefinedFields?: UserDefinedFieldsList;
      };
    })
  | null;
export type CompanyResponseList =
  | (ListResponse & {
      items?: Company[] | null;
    })
  | null;
export type CompanyResponse = Response & Company;
export type Product =
  | (LinkList & {
      data?: {
        /** ignored on POST and PATCH */
        productId?: string | null;
        name?: string | null;
        description?: string | null;
        /** Reference to the company that produces the product (aka the producer) */
        companyRef?: CompanyReference;
        typename?: string | null;
        classification?: Classification;
        newPrice?: number | null;
        warrantyYears?: number | null;
        serviceLifeYears?: number | null;
        userDefinedFields?: UserDefinedFieldsList;
      };
    })
  | null;
export type ProductResponseList =
  | (ListResponse & {
      items?: Product[] | null;
    })
  | null;
export type ProductResponse = Response & Product;
export type Invoice =
  | (LinkList & {
      data?: {
        /** ignored on POST and PATCH */
        invoiceId?: string | null;
        /** ignored on PATCH */
        invoiceNumber?: string | null;
        /** ignored on PATCH */
        notes?: string | null;
        /** ignored on PATCH */
        invoiceDate?: string | null;
        /** ignored on PATCH */
        dueDate?: string | null;
        /** ignored on PATCH */
        amount?: number | null;
        /** ignored on POST and PATCH */
        cvrNumber?: string | null;
        /** ignored on POST and PATCH */
        supplierName?: string | null;
        /** ignored on POST and PATCH */
        approvedBy?: string | null;
        /** ignored on POST and PATCH */
        approvedDate?: string | null;
        /** ignored on POST and PATCH */
        accountingDate?: string | null;
        status?: number | null;
        /** ignored on PATCH */
        relatedWorkOrderId?: number | null;
        /** ignored on PATCH */
        relatedServiceAgreementId?: number | null;
      };
    })
  | null;
export type InvoiceResponseList =
  | (ListResponse & {
      items?: Invoice[] | null;
    })
  | null;
export type InvoiceResponse = Response & Invoice;
export type InvoiceStatus = {
  invoiceStatusId?: string | null;
  name?: string | null;
} | null;
export type InvoiceStatusResponseList =
  | (ListResponse & {
      items?: InvoiceStatus[] | null;
    })
  | null;
export type ChecklistTemplateReference = {
  templateName?: string | null;
} | null;
export type ChecklistStatus = {
  state?: string | null;
} | null;
export type ChecklistDataLimited = {
  checklistId?: string | null;
  name?: string | null;
  number?: string;
  templateRef?: ChecklistTemplateReference;
  workOrderRefs?: WorkOrderReference[] | null;
  assetRefs?: AssetReference[] | null;
  status?: ChecklistStatus;
  required?: boolean | null;
  createdDate?: string | null;
  lastChangeDate?: string | null;
  deadlineDate?: string | null;
  responsible?: string | null;
  completedBy?: string | null;
} | null;
export type ChecklistLimited =
  | (LinkList & {
      data?: ChecklistDataLimited;
    })
  | null;
export type ChecklistResponseList =
  | (ListResponse & {
      items?: ChecklistLimited[] | null;
    })
  | null;
export type ChecklistData =
  | (ChecklistDataLimited & {
      userDefinedFields?: UserDefinedFieldsList;
    })
  | null;
export type Checklist =
  | (LinkList & {
      data?: ChecklistData;
    })
  | null;
export type ChecklistResponse = Response & Checklist;
export type MediaReference = {
  fileName?: string | null;
  url?: string | null;
} | null;
export type ChecklistAttachmentValue = {
  workOrderReference?: WorkOrderReference;
  ticketReference?: TicketReference;
  mediaReference?: MediaReference;
  comment?: string | null;
} | null;
export type ChecklistAttachment =
  | (LinkList & {
      data?: {
        checklistItemName?: string | null;
        values?: ChecklistAttachmentValue[] | null;
      };
    })
  | null;
export type ChecklistAttachmentResponseList =
  | (ListResponse & {
      items?: ChecklistAttachment[] | null;
    })
  | null;
export type Zone =
  | (LinkList & {
      data?: {
        /** ignored on POST and PATCH */
        zoneId?: string | null;
        /** ignored on POST and PATCH */
        name?: string | null;
        /** ignored on POST and PATCH */
        description?: string | null;
        /** ignored on POST and PATCH */
        floorRefs?: FloorReference[] | null;
        /** ignored on POST and PATCH */
        grossAreaFromRooms?: number | null;
        /** ignored on POST and PATCH */
        netAreaFromRooms?: number | null;
        /** ignored on POST and PATCH */
        lastChangeDate?: string | null;
        /** ignored on POST and PATCH */
        lastChangedBy?: string | null;
        /** ignored on POST and PATCH */
        createdDate?: string | null;
        /** ignored on POST and PATCH */
        createdBy?: string | null;
        userDefinedFields?: UserDefinedFieldsList;
      };
    })
  | null;
export type ZoneResponseList =
  | (ListResponse & {
      items?: Zone[] | null;
    })
  | null;
export type ZoneResponse = Response & Zone;
export const {
  useSearchLocationsQuery,
  useSearchEstateQuery,
  useAddEstateMutation,
  useGetEstateQuery,
  useUpdateEstateMutation,
  useGetEstateBuildingsQuery,
  useGetEstateLotsQuery,
  useSearchBuildingQuery,
  useAddBuildingMutation,
  useGetBuildingQuery,
  useUpdateBuildingMutation,
  useSearchBuildingFloorsQuery,
  useSearchBuildingAssetsQuery,
  useSearchBuildingDocumentsQuery,
  useSearchBuildingWorkOrdersQuery,
  useGetBuildingPolygonQuery,
  useUpdatePolygonMutation,
  useGetBuildingContactPersonsQuery,
  usePostContactPersonsMutation,
  useSearchLotQuery,
  useAddLotMutation,
  useGetLotQuery,
  useUpdateLotMutation,
  useGetLotPolygonQuery,
  useAddPolygonMutation,
  useGetAllFloorsQuery,
  useAddFloorMutation,
  useGetFloorQuery,
  useUpdateFloorMutation,
  useSearchFloorRoomsQuery,
  useSearchRoomQuery,
  useGetRoomQuery,
  useUpdateRoomMutation,
  useGetRoomPolygonQuery,
  useSearchDocumentQuery,
  useCreateDocumentMutation,
  useGetDocumentQuery,
  useUpdateDocumentMutation,
  useGetBinaryDocumentQuery,
  useGetBinaryFileDocumentQuery,
  useCreateUploadSessionQuery,
  useUploadFileMutation,
  useUploadFilePartMutation,
  useSearchAssetQuery,
  useAddAssetMutation,
  useGetAssetQuery,
  useUpdateAssetMutation,
  useSearchSubAssetsQuery,
  useSearchAssetDocumentsQuery,
  useSearchAssetWorkOrdersQuery,
  useSearchAssetPhotosQuery,
  useSearchClassificationQuery,
  useSearchWorkOrderQuery,
  useCreateWorkOrderMutation,
  useGetWorkOrderQuery,
  useUpdateWorkOrderMutation,
  useSearchWorkOrderDocumentsQuery,
  useCreateDocumentOnWorkOrderMutation,
  useSearchWorkOrderPhotosQuery,
  useCreatePhotoOnWorkOrderMutation,
  useSearchWorkOrderHistoryQuery,
  useSearchWorkOrderTimeRegistrationsQuery,
  useSearchWorkOrderTemplatesQuery,
  useSearchWorkOrderPrioritiesQuery,
  useSearchTeamsQuery,
  useSearchWorkOrderStatusesQuery,
  useSearchWorkOrderTimeAccountsQuery,
  useSearchExternalWorkOrderQuery,
  useGetExternalWorkOrderQuery,
  useUpdateExternalWorkOrderMutation,
  useSearchExternalWorkOrderHistoryQuery,
  useCreateNoteMutation,
  useSendMessageMutation,
  useAddInformationMutation,
  useAddTimeUsageMutation,
  useConfirmWorkOrderExternalMutation,
  useRejectWorkOrderExternalMutation,
  useCompleteWorkOrderExternalMutation,
  useSearchExternalWorkOrderStatusesQuery,
  useSearchTicketQuery,
  useCreateTicketMutation,
  useGetTicketQuery,
  useUpdateTicketMutation,
  useSearchTicketHistoryQuery,
  useSearchTicketPhotosQuery,
  useSearchTicketTopicsQuery,
  useSearchTicketTopicBuildingsQuery,
  useSearchTicketTopicClassificationsQuery,
  useSearchTicketTopicLotsQuery,
  useSearchTicketTopicRoomTypesQuery,
  useSearchStatusesQuery,
  useSendMessagePhotoMutation,
  useSearchCompanyQuery,
  useGetCompanyQuery,
  useSearchCompanyWorkOrdersQuery,
  useSearchProductQuery,
  useCreateProductMutation,
  useGetProductQuery,
  useUpdateProductMutation,
  useSearchProductsDocumentsQuery,
  useSearchInvoiceQuery,
  useCreateInvoiceMutation,
  useGetInvoiceQuery,
  useUpdateInvoiceMutation,
  useSearchInvoicesDocumentsQuery,
  useCreateDocumentOnInvoiceMutation,
  useSearchInvoiceStatusesQuery,
  useSearchChecklistQuery,
  useGetChecklistQuery,
  useSearchChecklistAttachmentQuery,
  useSearchZonesQuery,
  useGetZoneQuery,
  useSearchZoneDocumentsQuery,
} = injectedRtkApi;
